import { useRecoilTransaction_UNSTABLE } from "recoil"

import { findScrollPositionState } from "~/containers/LegacyDesigner/state/scroll"

import type { TransactionOperation } from "."
import { zoomState } from "../../view"

export const resetZoomAndPan: TransactionOperation = ({ set, get }) => {
  const panState = findScrollPositionState(`Studio`)
  const newPan = {
    x: 0,
    y: 0,
  }
  const resetZoom = 100
  set(panState, newPan)
  set(zoomState, resetZoom)
}

export const useResetZoomAndPan = (): VoidFunction =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => resetZoomAndPan(transactors),
  )
